import { render, staticRenderFns } from "./DetailMinTable.vue?vue&type=template&id=77274484&scoped=true&"
import script from "./DetailMinTable.vue?vue&type=script&lang=js&"
export * from "./DetailMinTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailMinTable.vue?vue&type=style&index=0&id=77274484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77274484",
  null
  
)

export default component.exports